import { dueStatus, type DueStatus } from '@/lib/dueStatus';

/**
 * Submittal review-due status. Thin wrapper over the shared `dueStatus` helper
 * (lib/dueStatus) keyed off `reviewDue`. Kept as a named export so existing
 * call sites (the submittals list/detail and the reminder composer) are
 * unchanged; the thresholds + labels live in `dueStatus` now.
 */
export type ReviewDueStatus = DueStatus;

export function reviewDueStatus(reviewDue: string | null | undefined): ReviewDueStatus {
  return dueStatus(reviewDue);
}
